import {AppBar, Checkbox, Divider, IconButton, Toolbar, Tooltip} from '@mui/material'
import GridViewIcon from '@mui/icons-material/GridView'
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted'
import './SearchToolBar.scss'
import {SelectPageSizeWithMenu} from '../PageSelection/SelectPageSizeWithMenu'
import AddToListButton from '../../../../genericComponents/AddToListButton'
import ResultsSelectedTag from '../ResultsSelectedTag/ResultsSelectedTag'
import {ItemsExtraction} from '../ItemsExtraction/ItemsExtraction'
import DeleteItemFromListDialog from '../../../../itemList/DeleteItemFromList/DeleteItemFromListDialog'
import React, {useState} from 'react'
import {ItemList} from '../../../../itemList/model/ItemList'
import {DeleteForever} from '@mui/icons-material'
import {FullSearchResult} from '../../useFullSearch'


const SearchToolBarForItemSearch = ({
                                        fullSearchResult,
                                        currentList
                                    }: {
    fullSearchResult: FullSearchResult,
    currentList?: ItemList | null
}) => {
    const {
        searchResult,
        searchResultControl: {
            addPageResultToSelection,
            clearPageSelection,
            setLegacyView,
            legacyView,
            isAnItemInPageSelected,
            areAllItemsInPageSelected,
            startIndex,
            endIndex,
            selectedItems,
            handleAddMultipleItemsToList,
            resetMultiSelect
        },
    } = fullSearchResult
    const noItemSelected = selectedItems.length === 0

    const [isDialogOpen, setIsDialogOpen] = useState(false)
    const handleCloseDeleteDialog = () => setIsDialogOpen(false)

    const deleteItems = () => setIsDialogOpen(true)

    return (<AppBar position="static" className="item-search-toolbar-container">
        <Toolbar variant="dense" className="item-search-toolbar">
            <Checkbox
                data-testid="check-all-items"
                checked={areAllItemsInPageSelected()}
                indeterminate={isAnItemInPageSelected() && !areAllItemsInPageSelected()}
                onClick={() => {
                    if (!areAllItemsInPageSelected()) {
                        addPageResultToSelection()
                    } else {
                        clearPageSelection()
                    }
                }}
            />

            <Divider orientation="vertical" variant="middle" flexItem/>

            <AddToListButton onClick={handleAddMultipleItemsToList} tooltip="Create new list from selection"
                             isDisabled={noItemSelected} isSearchToolbarButton={true}/>

            <ItemsExtraction selectedItems={selectedItems} isDisabled={noItemSelected}/>

            {currentList && <Tooltip title="Delete selected items from list">
                <span>
                    <IconButton aria-label="delete"
                                disabled={noItemSelected}
                                onClick={deleteItems}
                                color="primary"
                                data-testid="delete-icon"
                    >
                        <DeleteForever className={'more-actions-option'}/>
                    </IconButton>
                </span>
            </Tooltip>}

            <Divider orientation="vertical" variant="middle" flexItem/>
            <Tooltip title={legacyView ? 'Switch to table view' : 'Switch to card view'}>
              <span>
                <IconButton aria-label="toggle-legacy-view" onClick={() => setLegacyView(!legacyView)} color="primary">
                  {legacyView ? <FormatListBulletedIcon/> : <GridViewIcon/>}
                </IconButton>
              </span>
            </Tooltip>

            <ResultsSelectedTag resultsList={selectedItems}
                                resetResults={resetMultiSelect}
            />

            <SelectPageSizeWithMenu startIndex={startIndex} endIndex={endIndex} totalResultCount={searchResult?.totalElements ?? 0}/>
        </Toolbar>
        <DeleteItemFromListDialog
            open={isDialogOpen}
            closeDialog={handleCloseDeleteDialog}
            itemsToDelete={selectedItems}
            currentList={currentList}
        />
    </AppBar>)
}

export default SearchToolBarForItemSearch
